export default __webpack_public_path__ + "static/media/Pitsenbargers400.17744bb0.jpg";